import { FC } from "react";
import { File } from "@ludens-reklame/rubics-v3-sdk/file/types";

interface EmbedVideo {
  embed?: string;
  caption?: string;
}

interface Props {
  video?: File;
  embedVideo?: EmbedVideo;
}

const Video: FC<Props> = ({ video, embedVideo }) => {
  if (!video && !embedVideo) return null;

  return (
    <div className="video">
      <div className="vs-l">
        {video ? (
          <>
            <video controls>
              <source src={video.url} type={video.mimeType} />
              Your browser does not support the video tag.
            </video>
            <p className="b4">{video.caption}</p>
          </>
        ) : embedVideo ? (
          <>
            <div
              className="embed"
              dangerouslySetInnerHTML={{ __html: embedVideo.embed || "" }}
            />
            <p className="b4">{embedVideo.caption}</p>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Video;
